<main id="main-content" class="main-content">
    <h2 class="form-header">{{page()}}. Team & Supporting Documents</h2>

    <mat-card style="margin-bottom: 24px;">
        <div class="title" id="supporting-documents-heading">Supporting Documents</div>

        <div class="table-container" aria-labelledby="supporting-documents-caption supporting-documents-heading">
            <table>
                <caption id="supporting-documents-caption" class="usa-sr-only">
                  Supporting Documents.
                </caption>
                <tr class="table-header">
                    <th>File Name</th>
                    <th>Box Link</th>
                </tr>
                <tr class="table-row">
                    <td class="text-cell">Supporting Documents Folder</td>
                    <td class="text-cell bold content-cell" *ngIf="report().supporting_documents">
                        <a class="standard-text"
                            [href]="decodeURI(report().supporting_documents)"
                            target="_blank">
                            <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                                aria-label="Open Link"></fa-icon>
                            Open file in Box
                        </a>
                    </td>
                    <td class="text-cell bold blank-cell" *ngIf="!report().supporting_documents">
                        --
                    </td>
                </tr>
                <tr class="table-row">
                    <td class="text-cell">Treatment Recommendations Map</td>
                    <td class="text-cell bold content-cell" *ngIf="report().recommendations_map">
                        <a class="standard-text"
                        [href]="decodeURI(report().recommendations_map)"
                            target="_blank">
                            <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                                aria-label="Open Link"></fa-icon>
                            Open file in Box
                        </a>
                    </td>
                    <td class="text-cell bold blank-cell" *ngIf="!report().recommendations_map">
                        --
                    </td>
                </tr>
                <tr class="table-row">
                    <td class="text-cell">Soil Burn Severity Map</td>
                    <td class="text-cell bold content-cell" *ngIf="report().burn_severity_map">
                        <a class="standard-text"
                        [href]="decodeURI(report().burn_severity_map)"
                            target="_blank">
                            <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                                aria-label="Open Link"></fa-icon>
                            Open file in Box
                        </a>
                    </td>
                    <td class="text-cell bold blank-cell" *ngIf="!report().burn_severity_map">
                        --
                    </td>
                </tr>
                <tr class="table-row">
                    <td class="text-cell">KMZ package</td>
                    <td class="text-cell bold content-cell" *ngIf="report().kmz_submittal_package">
                        <a class="standard-text"
                        [href]="decodeURI(report().kmz_submittal_package)"
                            target="_blank">
                            <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                                aria-label="Open Link"></fa-icon>
                            Open file in Box
                        </a>
                    </td>
                    <td class="text-cell bold blank-cell" *ngIf="!report().kmz_submittal_package">
                        --
                    </td>
                </tr>
                <tr class="table-row" *ngFor="let file of otherLinks">
                    <td class="text-cell">{{ file.file_name }}</td>
                    <td class="text-cell bold content-cell">
                        <a class="standard-text"
                        [href]="decodeURI(file.file_link)"
                            target="_blank">
                            <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                                aria-label="Open Link"></fa-icon>
                            Open link to file
                        </a>
                    </td>
                </tr>
            </table>
        </div>
    </mat-card>
    <mat-card>
        <div class="title">Team Roster</div>
        <div>
            <div class="text-div">
                <b>Team Leads</b>
            </div>
            <div class="contact-container">
                <div *ngFor="let user of users.data">
                    <mat-card *ngIf="user.role.role_id == 0 || user.role.role_id == 1" class="contact-card">
                        <div>
                            <div class="user-cell-name">
                                <div class="user-icon">
                                    <p>{{user.user.first_name[0]}}</p>
                                </div>
                                <a [routerLink]="['/user']" [queryParams]="{user_id: user?.user.user_id}"
                                    class="user-name">{{user.user.first_name + " " + user.user.last_name}}</a>
                            </div>
                            <div class="user-cell-details">
                                <mat-chip>{{ user.role.role }}</mat-chip>
                                <div class="details-number"><mat-icon>phone</mat-icon> {{(user.user.phone_num | phone)
                                    ||
                                    "--"}}
                                </div>
                                <div class="details-email"><mat-icon>email</mat-icon>{{user.user.email}}</div>
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
        <div *ngIf="forestContacts.length > 0">
            <div class="text-div">
                <b>Forest Coordinators</b>
            </div>
            <div class="contact-container">
                <mat-card *ngFor="let user of forestContacts" class="contact-card">
                    <div>
                        <div class="user-cell-name">
                            <div class="user-icon">
                                <p>{{user.first_name[0]}}</p>
                            </div>
                            <a [routerLink]="['/user']" [queryParams]="{user_id: user?.user_id}"
                                class="user-name">{{user.first_name + " " + user.last_name}}</a>
                        </div>
                        <div class="user-cell-details">
                            <mat-chip *ngFor="let role of user.showRoles">{{ role }}</mat-chip>
                            <div class="details-number"><mat-icon>phone</mat-icon> {{(user.phone_num | phone) ||
                                "--"}}
                            </div>
                            <div class="details-email"><mat-icon>email</mat-icon>{{user.email}}</div>
                            <div class="details-email"><mat-icon>location_on</mat-icon>1{{ user.isFOCO[0] }}</div>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>

        <div class="text-div" id="all-team-members-and-skills-heading">
            <b>All Team Members and Skills</b>
        </div>
        <table mat-table [dataSource]="users" class="center" aria-hidden="false"
          aria-labelledby="all-team-members-and-skills-caption all-team-members-and-skills-heading"
        >
            <caption id="all-team-members-and-skills-caption" class="usa-sr-only">
              All Team Members and Skills.
            </caption>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>

                <td class="user-cell" mat-cell *matCellDef="let user">
                    <div>
                        <div class="user-cell-name">
                            <div class="user-icon">
                                <p>{{user.user.first_name[0]}}</p>
                            </div>
                            <a [routerLink]="['/user']" [queryParams]="{user_id: user?.user.user_id}"
                                class="user-name">{{user.user.first_name + " " + user.user.last_name}}</a>
                        </div>
                        <div class="user-cell-details">
                            <div class="details-email"><mat-icon>email</mat-icon>{{user.user.email}}</div>
                        </div>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef>Role</th>
                <td mat-cell *matCellDef="let user" [style.background-color]="user.isSelected ? '#FFF5E1' : 'white'">
                    <mat-chip class="chip" *ngIf="user.role; else roleDef">{{user.role.role}}</mat-chip>
                    <ng-template #roleDef>--</ng-template>
                </td>
            </ng-container>
            <ng-container matColumnDef="skills">
                <th mat-header-cell *matHeaderCellDef>Skills</th>
                <td mat-cell *matCellDef="let user" [style.background-color]="user.isSelected ? '#FFF5E1' : 'white'">
                    <div *ngIf="user.skills.length != 0; else skillDef">
                        <mat-chip *ngFor="let skill of user.skills" class="chip">
                            {{ skill.other_skill ?? skill.skill.text }}
                        </mat-chip>
                    </div>
                    <ng-template #skillDef>--</ng-template>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="3">
                    <div class="no-data" *ngIf="pageLoaded">
                        <div class="no-data-icon">
                            <mat-icon class="no-data-icon1">search</mat-icon>
                            <fa-icon [icon]="faUsers" class="no-data-icon2"></fa-icon>
                        </div>
                        <div class="no-data-title">No users available</div>
                        <p>There are no users in this roster yet.</p>
                    </div>
                </td>
            </tr>
        </table>
    </mat-card>
</main>
